import TableCellLabels from "ds/components/Table/Row/CellLabels";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Plugin } from "types/generated";

const PluginsTableLabelsCell = ({ item: plugin, ...cellProps }: TableSimpleCellProps<Plugin>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellLabels tags={plugin.labels} />
    </TableSimpleCell>
  );
};

export default PluginsTableLabelsCell;
